/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Banner_Tool_Access_Admins_DescriptionInputs */



/**
* | output |
* | --- |
* | "A tool-access rule is workspace configuration, not a permission held by a person. Restricting the tools of an integration space restricts organization admini..." |
*
* @param {Rights_Banner_Tool_Access_Admins_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_banner_tool_access_admins_description = /** @type {((inputs?: Rights_Banner_Tool_Access_Admins_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Banner_Tool_Access_Admins_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine Tool-Zugriffsregel ist Workspace-Konfiguration und kein Recht an einer Person. Wer die Tools eines Integrations-Space einschränkt, schränkt Organisationsadministratoren genauso ein — auch die Person, die die Regel geschrieben hat.")
	return /** @type {LocalizedString} */ ("A tool-access rule is workspace configuration, not a permission held by a person. Restricting the tools of an integration space restricts organization administrators in exactly the same way — including the administrator who wrote the rule.")
});